module.exports = __webpack_public_path__ + "static/media/mobile.8139d116.png";